export default function getNamesForIDs(ids, definitions) {
  return ids.map((id) => definitions[id].name)
}
